/* eslint-disable import/prefer-default-export */
import {
  TravelAnalysisMessages,
  TranslationTravelAnalysisMessages
} from "../interfaces";

export const messages: TranslationTravelAnalysisMessages = {
  [TravelAnalysisMessages.pageTitle]: "Análisis de Viajes",
  [TravelAnalysisMessages.filterButton]: "Filtrar",
  [TravelAnalysisMessages.loading]: "Cargando...",
  [TravelAnalysisMessages.totalAnalyzed]: "Total Analizado",
  [TravelAnalysisMessages.successfulTrips]: "Viajes Exitosos",
  [TravelAnalysisMessages.successRate]: "Tasa de Éxito",
  [TravelAnalysisMessages.alertsDetected]: "Alertas Detectadas",
  [TravelAnalysisMessages.target]: "META",
  [TravelAnalysisMessages.alertDistributionTitle]: "Distribución de Alertas por Tipo",
  [TravelAnalysisMessages.noAlertsInPeriod]: "Sin alertas en el período",
  [TravelAnalysisMessages.successRatioTitle]: "Proporción Éxito vs Alertas",
  [TravelAnalysisMessages.noData]: "Sin datos",
  [TravelAnalysisMessages.success]: "Éxito",
  [TravelAnalysisMessages.alerts]: "Alertas",
  [TravelAnalysisMessages.efficiency]: "Eficiencia",
  [TravelAnalysisMessages.geographicMonitoringTitle]: "Monitoreo Geográfico",
  [TravelAnalysisMessages.geographicMonitoringSubtitle]: "Distribución de alertas por región de operación",
  [TravelAnalysisMessages.noGeographicData]: "Sin datos geográficos",
  [TravelAnalysisMessages.activeVehicles]: "Vehículos Activos",
  [TravelAnalysisMessages.activeAlerts]: "Alertas Activas",
  [TravelAnalysisMessages.dashboardSubtitle]: "DASHBOARD DE OPERACIONES",
  [TravelAnalysisMessages.percentOfTotal]: "del total",
  [TravelAnalysisMessages.alertsListTitle]: "Detalle de Alertas",
  [TravelAnalysisMessages.columnVehicle]: "Vehículo",
  [TravelAnalysisMessages.columnAlertType]: "Tipo de Alerta",
  [TravelAnalysisMessages.columnOrigin]: "Origen",
  [TravelAnalysisMessages.columnDestination]: "Destino",
  [TravelAnalysisMessages.columnDate]: "Fecha",
  [TravelAnalysisMessages.noAlertsFound]: "No se encontraron alertas",
  [TravelAnalysisMessages.loadMore]: "Cargar más",
  [TravelAnalysisMessages.close]: "Cerrar",
  [TravelAnalysisMessages.tripsUnit]: "viajes",
  [TravelAnalysisMessages.columnNumDoc]: "Nº Doc",
  [TravelAnalysisMessages.columnActions]: "Acciones",
  [TravelAnalysisMessages.viewAlertDetails]: "Detalles de la alerta",
  [TravelAnalysisMessages.viewTravel]: "Abrir viaje",
  [TravelAnalysisMessages.alertDetailsTitle]: "Detalles del Análisis",
  [TravelAnalysisMessages.loadingTravel]: "Cargando viaje...",
  // Metadata labels — CAN Data Stall
  [TravelAnalysisMessages.metaSource]: "Fuente de datos",
  [TravelAnalysisMessages.metaStallType]: "Tipo de estancamiento",
  [TravelAnalysisMessages.metaThreshold]: "Umbral",
  [TravelAnalysisMessages.metaStalledFields]: "Campos estancados",
  [TravelAnalysisMessages.metaTotalCanPackets]: "Total de paquetes CAN",
  // Cross Day Cycle
  [TravelAnalysisMessages.metaStartDate]: "Fecha de inicio",
  [TravelAnalysisMessages.metaFinishDate]: "Fecha de fin",
  [TravelAnalysisMessages.metaStartDay]: "Día de inicio",
  [TravelAnalysisMessages.metaFinishDay]: "Día de fin",
  [TravelAnalysisMessages.metaDurationHours]: "Duración (horas)",
  // False Positive Discharge
  [TravelAnalysisMessages.metaTotalDischargeCommands]: "Total de comandos de descarga",
  [TravelAnalysisMessages.metaCoveredCommands]: "Comandos cubiertos",
  [TravelAnalysisMessages.metaOrphanCommands]: "Comandos huérfanos",
  [TravelAnalysisMessages.metaOrphanRatio]: "Tasa de huérfanos (%)",
  [TravelAnalysisMessages.metaCoveredRanges]: "Períodos cubiertos",
  // GPRS Connection Instability
  [TravelAnalysisMessages.metaTotalPackets]: "Total de paquetes",
  [TravelAnalysisMessages.metaMemoryCommands]: "Comandos offline real",
  [TravelAnalysisMessages.metaEffectiveRealtimeCommands]: "Comandos efectivamente tiempo real",
  [TravelAnalysisMessages.metaRealtimeCommands]: "Comandos en tiempo real",
  [TravelAnalysisMessages.metaMemoryRatio]: "Tasa de offline real (%)",
  [TravelAnalysisMessages.metaThresholdPercent]: "Umbral (%)",
  [TravelAnalysisMessages.metaEffectiveRealtimeThresholdSeconds]: "Umbral de tiempo real efectivo (s)",
  [TravelAnalysisMessages.metaAvgDelaySeconds]: "Promedio de delay de transmisión (s)",
  [TravelAnalysisMessages.metaMaxDelaySeconds]: "Mayor delay de transmisión (s)",
  // GPS Positioning Failure
  [TravelAnalysisMessages.metaTotalGpsPackets]: "Total de paquetes GPS",
  [TravelAnalysisMessages.metaInvalidFixCount]: "Posiciones inválidas",
  [TravelAnalysisMessages.metaInvalidRatio]: "Tasa de inválidos (%)",
  [TravelAnalysisMessages.metaAvgSatellites]: "Promedio de satélites",
  // Hardware Command Deficit
  [TravelAnalysisMessages.metaPacketCount]: "Paquetes recibidos",
  [TravelAnalysisMessages.metaExpectedPackets]: "Paquetes esperados",
  [TravelAnalysisMessages.metaMinimumRequired]: "Mínimo requerido",
  [TravelAnalysisMessages.metaDeficitPercent]: "Déficit (%)",
  [TravelAnalysisMessages.metaRatePerMinute]: "Tasa por minuto",
  [TravelAnalysisMessages.metaTravelDurationMinutes]: "Duración del viaje (min)",
  // Logistics Flow Inconsistency
  [TravelAnalysisMessages.metaRequiredStates]: "Estados obligatorios",
  [TravelAnalysisMessages.metaActualStates]: "Estados presentes",
  [TravelAnalysisMessages.metaMissingStates]: "Estados ausentes",
  [TravelAnalysisMessages.metaMissingCount]: "Cantidad faltante",
  [TravelAnalysisMessages.metaTotalStates]: "Total de estados",
  [TravelAnalysisMessages.metaNumDoc]: "Nº documento",
  // Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.metaIgnitionOnCount]: "Comandos con ignición ON",
  [TravelAnalysisMessages.metaIdleCount]: "Comandos en IDLE",
  [TravelAnalysisMessages.metaLoadingCount]: "Comandos cargando",
  [TravelAnalysisMessages.metaUnloadingCount]: "Comandos descargando",
  [TravelAnalysisMessages.metaIdleRatio]: "Tasa de IDLE (%)",
  [TravelAnalysisMessages.successByDayTitle]: "Éxito por Día",
  [TravelAnalysisMessages.successByPlantTitle]: "Éxito por Central",
  [TravelAnalysisMessages.successByRegionalTitle]: "Éxito por Regional",
  [TravelAnalysisMessages.averageLine]: "Promedio",
  [TravelAnalysisMessages.noGroupedData]: "Sin datos para el período seleccionado",
  [TravelAnalysisMessages.coordinateViewTitle]: "Visualización de Coordenadas",
  [TravelAnalysisMessages.coordinateViewVehicle]: "Vehículo",
  [TravelAnalysisMessages.coordinateViewNF]: "NF",
  [TravelAnalysisMessages.coordinateViewGeneral]: "General",
  [TravelAnalysisMessages.coordinateViewContent]: "Contenido",
  [TravelAnalysisMessages.coordinateViewResult]: "Resultado",
  [TravelAnalysisMessages.coordinateViewGeneralData]: "Datos Generales",
  [TravelAnalysisMessages.coordinateViewCommandContent]: "Contenido del Comando",
  [TravelAnalysisMessages.coordinateViewProcessingResult]: "Resultado del Procesamiento",
  [TravelAnalysisMessages.coordinateViewNoData]: "Sin datos",
  [TravelAnalysisMessages.coordinateViewField]: "Campo",
  [TravelAnalysisMessages.coordinateViewValue]: "Valor",
  // Alert glossary (help drawer)
  [TravelAnalysisMessages.glossaryButtonLabel]: "Sobre las alertas",
  [TravelAnalysisMessages.glossaryDrawerTitle]: "Entienda las Alertas de Viaje",
  [TravelAnalysisMessages.glossaryIntroTitle]: "Cómo funciona el análisis",
  [TravelAnalysisMessages.glossaryIntroText]:
    "El análisis se ejecuta automáticamente en cuanto un viaje se cierra. En ese momento, el viaje entra en una cola y un proceso en segundo plano reúne todos sus datos — estados del vehículo, eventos, coordenadas y los paquetes brutos recibidos del rastreador durante el período del viaje — y aplica las verificaciones de abajo. Cada verificación que identifica una anomalía genera una alerta con sus detalles. Los viajes que no generan ninguna alerta se contabilizan como éxito en la tasa mostrada en el panel.",
  [TravelAnalysisMessages.glossaryWhenLabel]: "Cuándo se dispara",
  [TravelAnalysisMessages.glossaryAppliesLabel]: "Se aplica a",
  [TravelAnalysisMessages.glossaryMetadataLabel]: "Detalles capturados (metadatos)",
  [TravelAnalysisMessages.glossaryAppliesAll]: "Todos los vehículos",
  [TravelAnalysisMessages.glossaryAppliesMixerPump]: "Hormigoneras y camiones bomba",
  [TravelAnalysisMessages.glossaryAppliesMixer]: "Hormigoneras",
  [TravelAnalysisMessages.glossaryAppliesMixerDoc]: "Hormigoneras con Nº de documento (viaje de hormigón)",
  // Glossary — GPRS Connection Instability
  [TravelAnalysisMessages.glossaryGprsTitle]: "Inestabilidad de conexión GPRS",
  [TravelAnalysisMessages.glossaryGprsDesc]:
    "Indica que el rastreador perdió la señal de datos (GPRS) durante el viaje. Los paquetes capturados sin conexión quedan guardados en la memoria del equipo y solo llegan al servidor cuando la señal vuelve, con retraso. Un volumen alto de estos paquetes atrasados sugiere mala cobertura o un problema de operadora/SIM, y puede dejar tramos sin rastro en el trayecto.",
  [TravelAnalysisMessages.glossaryGprsWhen]:
    "Cuando el 30% o más de los paquetes llegaron atrasados desde la memoria (retraso de transmisión de 60s o más). Los paquetes de memoria que llegan en menos de 60s se tratan como tiempo real y no cuentan.",
  [TravelAnalysisMessages.glossaryGprsMeta]:
    "Los números muestran cuántos paquetes llegaron en tiempo real, cuántos llegaron realmente atrasados desde la memoria y el retraso medio y máximo de transmisión — cuanto mayor el retraso, peor estaba la señal.",
  // Glossary — GPS Positioning Failure
  [TravelAnalysisMessages.glossaryGpsTitle]: "Falla de posicionamiento GPS",
  [TravelAnalysisMessages.glossaryGpsDesc]:
    "Indica que el equipo no logró obtener una posición confiable de satélite en buena parte del viaje. Puede ocurrir por obstrucción (túneles, áreas cerradas), problema en la antena o pocos satélites visibles, afectando la precisión del trayecto registrado.",
  [TravelAnalysisMessages.glossaryGpsWhen]:
    "Cuando el 30% o más de los paquetes con datos de GPS no tenían fijación válida de satélite (FIX inválido).",
  [TravelAnalysisMessages.glossaryGpsMeta]:
    "Muestran el total de paquetes GPS, cuántos estaban sin fijación y el promedio de satélites captados — promedios bajos refuerzan la dificultad de recepción.",
  // Glossary — Cross Day Cycle
  [TravelAnalysisMessages.glossaryCrossDayTitle]: "Ciclo transversal (D+1)",
  [TravelAnalysisMessages.glossaryCrossDayDesc]:
    "Señala viajes que comenzaron en un día y solo terminaron al día siguiente. Ese 'cambio de día' impacta el cierre de productividad diaria, ya que el viaje aparece en dos días diferentes.",
  [TravelAnalysisMessages.glossaryCrossDayWhen]:
    "Cuando el día de inicio es diferente del día de fin y el viaje duró 6 horas o más (los viajes cortos que solo cruzan la medianoche se ignoran).",
  [TravelAnalysisMessages.glossaryCrossDayMeta]:
    "Muestran las fechas y los días de inicio y fin, además de la duración total del viaje en horas.",
  // Glossary — Hardware Command Deficit
  [TravelAnalysisMessages.glossaryHwDeficitTitle]: "Déficit de comandos de hardware enviados",
  [TravelAnalysisMessages.glossaryHwDeficitDesc]:
    "Indica que el rastreador transmitió menos paquetes de los esperados para la duración del viaje. Puede señalar un equipo con falla, apagado parte del tiempo o con problema de transmisión, reduciendo la confiabilidad de los datos del viaje.",
  [TravelAnalysisMessages.glossaryHwDeficitWhen]:
    "Cuando el número de paquetes recibidos quedó por debajo del 50% de lo esperado (referencia de 1 paquete cada 2 minutos). Evaluado solo en viajes de más de 5 minutos.",
  [TravelAnalysisMessages.glossaryHwDeficitMeta]:
    "Comparan los paquetes recibidos con los esperados y muestran el déficit porcentual y la tasa de paquetes por minuto.",
  // Glossary — Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.glossarySensorIdleTitle]: "Déficit de comandos de sensor activo (IDLE elevado)",
  [TravelAnalysisMessages.glossarySensorIdleDesc]:
    "Indica que, con el vehículo encendido, el tambor quedó detenido — sin cargar ni descargar — durante buena parte del viaje. Puede señalar un sensor del tambor con falla o un problema de comunicación, perjudicando la lectura de las etapas de carga y descarga.",
  [TravelAnalysisMessages.glossarySensorIdleWhen]:
    "Cuando, entre los paquetes con ignición encendida, el 50% o más tenían el tambor detenido (IDLE). Evaluado con al menos 10 paquetes de ignición encendida.",
  [TravelAnalysisMessages.glossarySensorIdleMeta]:
    "Muestran cuántos paquetes tenían ignición encendida y, de esos, cuántos estaban cargando, descargando o detenidos (IDLE).",
  // Glossary — Logistics Flow Inconsistency
  [TravelAnalysisMessages.glossaryLogisticsTitle]: "Inconsistencia de flujo logístico",
  [TravelAnalysisMessages.glossaryLogisticsDesc]:
    "Señala viajes de hormigón que no pasaron por todos los estados esperados del ciclo (En la planta → En camino → En obra → Descargando → Regresando). La ausencia de un estado puede indicar falla de detección, trayecto atípico o un problema en el registro del viaje.",
  [TravelAnalysisMessages.glossaryLogisticsWhen]:
    "Cuando falta al menos uno de los estados obligatorios. Verifica la presencia de cada estado, no el orden.",
  [TravelAnalysisMessages.glossaryLogisticsMeta]:
    "Listan los estados obligatorios, los que ocurrieron y los que faltaron en el viaje.",
  // Glossary — CAN Data Stall
  [TravelAnalysisMessages.glossaryCanStallTitle]: "Información de CAN estancada (completa o parcial)",
  [TravelAnalysisMessages.glossaryCanStallDesc]:
    "Indica que datos provenientes del bus CAN del vehículo (velocidad, RPM, combustible, odómetro) quedaron 'congelados', repitiendo el mismo valor en varios paquetes seguidos. Suele señalar una falla en la lectura del CAN, perjudicando la telemetría del vehículo.",
  [TravelAnalysisMessages.glossaryCanStallWhen]:
    "Cuando algún campo del CAN repite el mismo valor en 10 paquetes consecutivos o más. 'Total' = todos los campos congelados; 'Parcial' = al menos un campo congelado.",
  [TravelAnalysisMessages.glossaryCanStallMeta]:
    "Muestran qué campos se estancaron, durante cuántos paquetes seguidos y el valor que quedó repetido.",
  // Glossary — False Positive Discharge
  [TravelAnalysisMessages.glossaryFalseDischargeTitle]: "Falsos positivos de descarga",
  [TravelAnalysisMessages.glossaryFalseDischargeDesc]:
    "Señala comandos de descarga del tambor que ocurrieron fuera de cualquier contexto válido de descarga (sin estar descargando, en la planta, en un lugar confiable o en un evento de descarga indebida). Estos comandos 'huérfanos' pueden ser ruido de sensor o descargas no detectadas correctamente.",
  [TravelAnalysisMessages.glossaryFalseDischargeWhen]:
    "Cuando hay 3 o más comandos de descarga huérfanos (no cubiertos por ningún período de descarga conocido).",
  [TravelAnalysisMessages.glossaryFalseDischargeMeta]:
    "Muestran el total de comandos de descarga, cuántos estaban cubiertos por un contexto válido y cuántos quedaron huérfanos."
};
